/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="85.42"
        viewBox="0 0 82.25 85.42"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M55.41 7.32a1.252 1.252 0 0 1 .13 2.5h-28.7a1.25 1.25 0 0 1-.12-2.49h28.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M15.08 7.32a1.25 1.25 0 0 1 .13 2.49H3.56a1.06 1.06 0 0 0-1.05 1V81.9a1.07 1.07 0 0 0 1 1h75.24a1.08 1.08 0 0 0 1.06-1V10.88a1.07 1.07 0 0 0-.94-1.05h-11.7a1.25 1.25 0 0 1-.13-2.49h11.65a3.57 3.57 0 0 1 3.56 3.37v71.17a3.57 3.57 0 0 1-3.37 3.55H3.56A3.57 3.57 0 0 1 0 82V10.88a3.56 3.56 0 0 1 3.37-3.55h11.71Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M37.02 58.46h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .71-.71h8.07a.71.71 0 0 1 .71.71v8.07a.71.71 0 0 1-.71.71M20.74 58.46h-8.07a.72.72 0 0 1-.72-.71v-8.07a.72.72 0 0 1 .72-.71h8.07a.71.71 0 0 1 .71.71v8.07a.71.71 0 0 1-.71.71M53.3 58.46h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .71-.71h8.07a.72.72 0 0 1 .72.71v8.07a.72.72 0 0 1-.72.71M69.58 58.46H61.5a.71.71 0 0 1-.72-.71v-8.07a.71.71 0 0 1 .72-.68h8.06a.71.71 0 0 1 .72.71v8.07a.71.71 0 0 1-.72.71M37.02 74.77h-8.07a.71.71 0 0 1-.71-.72V66a.71.71 0 0 1 .71-.72h8.07a.71.71 0 0 1 .71.72v8.06a.71.71 0 0 1-.71.72M20.74 74.77h-8.07a.72.72 0 0 1-.72-.72V66a.72.72 0 0 1 .72-.72h8.07a.71.71 0 0 1 .76.72v8.06a.71.71 0 0 1-.71.72M53.3 74.77h-8.07a.71.71 0 0 1-.71-.72V66a.71.71 0 0 1 .71-.72h8.07a.72.72 0 0 1 .72.72v8.06a.72.72 0 0 1-.72.72"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M37.02 42.16h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .71-.72h8.07a.71.71 0 0 1 .71.72v8.07a.71.71 0 0 1-.71.71"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M53.3 42.16h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .71-.72h8.07a.72.72 0 0 1 .72.72v8.07a.72.72 0 0 1-.72.71M69.58 42.16H61.5a.71.71 0 0 1-.72-.71v-8.07a.72.72 0 0 1 .72-.72h8.06a.72.72 0 0 1 .72.72v8.07a.71.71 0 0 1-.72.71"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M81 22a1.252 1.252 0 0 1 .13 2.5H1.25a1.252 1.252 0 0 1-.13-2.5H81ZM26.34 0H15.58a1.76 1.76 0 0 0-1.75 1.75v11.61a1.75 1.75 0 0 0 1.75 1.75h10.76a1.75 1.75 0 0 0 1.75-1.75V1.75A1.75 1.75 0 0 0 26.34 0Zm-.75 2.5v10.11h-9.26V2.5ZM66.67 0H55.91a1.75 1.75 0 0 0-1.75 1.75v11.61a1.75 1.75 0 0 0 1.75 1.75h10.76a1.75 1.75 0 0 0 1.75-1.75V1.75A1.76 1.76 0 0 0 66.67 0Zm-.75 2.5v10.11h-9.26V2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'CalendarIcon';

export default Icon;
